// 그룹 std_key를 두 개의 큰 섹션으로 분류한다.
// - custom (개발/구현, 맞춤 개발): infraSetting, function
// - template (공통 솔루션, 템플릿/개통): 그 외 전부

export const SECTION_CUSTOM = 'custom';
export const SECTION_TEMPLATE = 'template';

const CUSTOM_GROUP_KEYS = new Set(['infraSetting', 'function']);

export function getSectionKey(stdKey) {
  return CUSTOM_GROUP_KEYS.has(stdKey) ? SECTION_CUSTOM : SECTION_TEMPLATE;
}

export const SECTION_META = {
  [SECTION_CUSTOM]: {
    title: '개발/구현 (맞춤 개발)',
    description: '고객 요구사항에 맞춰 개발하는 맞춤형 시스템',
  },
  [SECTION_TEMPLATE]: {
    title: '공통 솔루션 (템플릿/개통)',
    description: '사전 구축된 솔루션을 개통하여 사용하는 시스템',
  },
};

// 그룹 카드에 표시할 작은 라벨 (필수/맞춤/템플릿 구분)
const GROUP_TAG_OVERRIDE = {
  infraSetting: '기본 제공',
  function: '맞춤 개발',
};

export function getGroupTag(stdKey) {
  if (GROUP_TAG_OVERRIDE[stdKey]) return GROUP_TAG_OVERRIDE[stdKey];
  return '템플릿/개통';
}

// 그룹 리스트를 섹션별로 분리한 객체 반환
export function splitGroupsBySection(groupList) {
  const result = { [SECTION_CUSTOM]: [], [SECTION_TEMPLATE]: [] };
  (groupList || []).forEach(g => {
    const section = getSectionKey(g.std_key);
    result[section].push(g);
  });
  return result;
}
